// /client/src/composables/useMouseInteraction.js
import * as THREE from 'three'

let mouse = new THREE.Vector2()
let lastMouse = new THREE.Vector2()
let swipeVector = new THREE.Vector2()

export function setupMouseTracking(container, onSwipe, options = {}) {
    const {
        minSwipeDistance = 0.002, // default sensitivity
        passMouseVec = false,     // allow cleaner support for both
    } = options
    const rect = container.getBoundingClientRect()

    function onMouseMove(event) {
        const rect = container.getBoundingClientRect()
        mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1
        mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1

        swipeVector.subVectors(mouse, lastMouse)

        if (swipeVector.length() > minSwipeDistance) {
            if (passMouseVec) {
                onSwipe(swipeVector.clone(), mouse.clone())
            } else {
                onSwipe(swipeVector.clone())
            }
        }

        lastMouse.copy(mouse)
    }

    window.addEventListener('mousemove', onMouseMove)

    return () => {
        window.removeEventListener('mousemove', onMouseMove)
    }
}
        


export function getSwipeRay(camera, mouseVec2) {
  const raycaster = new THREE.Raycaster()
  raycaster.setFromCamera(mouseVec2, camera)
  return raycaster.ray
}
